'use strict'

export const SET_PENDING_DAYS = "SET_PENDING_DAYS";
export const SET_ACTION_TYPE = "SET_ACTION_TYPE";
export const DEFAULT_DAYS = 7;
export const DEFAULT_ACTION_TYPE = "";

export const RANGE_OPTIONS = [
    { label: '24 Hrs', value: 1 },
    { label: '7 Days', value: 7 },
    { label: '30 Days', value: 30 },
    { label: '90 Days', value: 90 },
];

export const ACTION_TYPE_OPTIONS = [
    { label: 'EMAIL', value: 'EMAIL' },
    { label: 'SR', value: 'SR' },
];
export const FETCH_RULE_LIST_REQUEST = "FETCH_RULE_LIST_REQUEST";
export const FETCH_RULE_LIST_SUCCESS = "FETCH_RULE_LIST_SUCCESS";
export const FETCH_RULE_LIST_FAILURE = "FETCH_RULE_LIST_FAILURE";
export const RESET_RULE_LIST_DATA = "RESET_RULE_LIST_DATA";
export const OPEN_EXPRESSION_POPUP = "OPEN_EXPRESSION_POPUP";
export const CLOSE_EXPRESSION_POPUP = "CLOSE_EXPRESSION_POPUP";
export const FETCH_SERVICE_MAX_URL_SUCCESS = "FETCH_SERVICE_MAX_URL_SUCCESS";